import React, { Component } from 'react';
import {observer} from 'mobx-react';
import {toJS} from 'mobx';
import { Dialog, Button, 
         DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

// Quick edit dialog takes these props:
// title = string
// fields = [ list of field names ]
// record = a draft copy of a record to be operated upon, use createViewModel in mobx 
// getFieldLabel = fun(fieldName) -> label
// onSave = fun(record) -> void; callback to provide client with modified record
@observer 
class QuickEditDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isErrorOpen: false,
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps) {

  }

  toggleDialog() {
    console.log('toggling! edit dialog');
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const attributes = this.props.fields;
    if (!this.state.isOpen) {
      return (
        <Button
          margin='dense' 
          variant='outlined'
          onClick={() => this.setState({ isOpen: true })}
          disabled={this.props.disabled}
        >
          Edit
        </Button>
      );
    }
    //console.log('Generating edit dialog');
    //let record = createViewModel(this.props.getRecord());
    let record = this.props.record;
    return (
      <Dialog
        maxWidth={'xs'}
        open={this.state.isOpen}
        onClose={() => this.toggleDialog()} 
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>
          {attributes.map((key) => {
            return (
	      <TextField
                key={key}
                fullWidth
                variant='outlined'
                //value={this.state.record ? this.state.record[key] : ''}
                defaultValue={record ? record[key] : ''}
                label={this.props.getFieldLabel(key)}
                onChange={(e) => {
                  record[key] = e.target.value;
                }}
              />
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            variant='contained'
            color='primary'
            onClick={() => {
              console.log('Saving', toJS(record));
              this.props.onSave(record);
              this.setState({isOpen: false});
            }}
          >Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

}

export default QuickEditDialog;
